/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Filters_Any_ProviderInputs */

const es_settings_files_filters_any_provider = /** @type {(inputs: Settings_Files_Filters_Any_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cualquier proveedor…`)
};

const en_settings_files_filters_any_provider = /** @type {(inputs: Settings_Files_Filters_Any_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any provider…`)
};

/**
* | output |
* | --- |
* | "Any provider…" |
*
* @param {Settings_Files_Filters_Any_ProviderInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_filters_any_provider = /** @type {((inputs?: Settings_Files_Filters_Any_ProviderInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Filters_Any_ProviderInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_filters_any_provider(inputs)
	return en_settings_files_filters_any_provider(inputs)
});
export { settings_files_filters_any_provider as "settings.files.filters.any_provider" }